import React from 'react'

import {
  // FormFooter,
  ModalAlert,
  Input,
  FormGroup,
  // Modal,
  Button,
  StatusDot,
  ContentBlock,
  Card,
  Icon,
  Select,
  // Head,
  Checkbox,
  Textarea,
  ImagePicker
} from "xsolla-uikit";

import { xsollaProducts } from '../data/xsollaProducts';

import { Switch, Route, Link } from "react-router-dom";


import { ProductIcon } from "./ProductIcon";



export const defaultSolutions = [
  {

    badgeText: "Hire Dr Disrespect to play your game",
    title: "Reach the world with Xsolla Marketing Cloud solution",
    description: "Connect with as many as 1.25 billion potential players when you create, measure, optimize, and grow all your revenue share programs from one place.Distribute offers to 650K+ influencers and 50+ affiliate networks worldwide, while maintaining full control over all your relationships and data.",
    descrLong: "Long Description",
    image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3fe504bb75e8c689104f27_Xsolla---User-acquisition-hi-rez.jpg",
    icon: false,
    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    badgeText: "Used by Twitch",
    title: "Boost revenue by unlocking South Korea, the most gaming oriented country",
    description: "New digital wallets like Toss, NaverPay and KakaoPay conquered the e-commerce market and now on their way to gaming vertical. Be among first companies to adopt advanced technologies and win Korean market.",
    descrLong: "Long Description",
    image: false,
    icon: false,
    intTime: "less than 3 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    badgeText: "Your account manager recommends",
    title: "Connect Alipay to drive payments in China",
    description: "Alipay lets you drive growth through direct relationships with players in China— while keeping their data under your control — and easy communications via pre-integrated modules and 3rd-party connectors.",
    descrLong: false,
    image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d32a9bd32a801404df5c453_china.png",
    icon: false,
    intTime: "less than 3 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    badgeText: "Used by Twitch",
    title: "Set up SEO settings for your project {ProjectName}",
    description: "Grow your organic traffic via setting Google search results preview and sharing options for your Landing Page.",
    descrLong: false,
    image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3055fdbe8118a6072c1e1a_2018-05-03%2001_15_49.gif",
    icon: false,
    intTime: "less than 5 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  }
];







export const gameStoreSolutions = [

  {
    tag: ['after', 'launch'],
    platform: ['win', 'web'],
    monetization: ['premium'],

    badgeText: "Before launch",
    title: "Distribute your digital game or content",
    description: "Send your game to players as a self-contained file instead of a game key, linking them to the download site from within their purchase confirmation.",
    descrLong: "Long Description",
    image: "https://uploads-ssl.webflow.com/5d2d1e42b1d78992ec4bcf44/5dc6410b52f69fba7785b0d6_BB_sell-your-game_2.jpg",
    icon: false,
    link: '/game_store/new',

    callToAction__title: 'Create widget',

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    monetization: ['microtransactions', 'premium', 'funding'],
    tag: ['before'],
    platform: ['win', 'web', 'console', 'mobile'],

    image: "https://uploads-ssl.webflow.com/5d2d1e42b1d78992ec4bcf44/5dcbc0a990ed862f0b3548b2_pre.jpg",
    badgeText: "For early stages",
    title: "Start a pre-orders or crowdfunding campaign",
    description: "Drive valuable pre-sales to deepen your development and marketing funds, grow your player base, and test your build before your official launch.",
    descrLong: "Long Description",
    // image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3fe504bb75e8c689104f27_Xsolla---User-acquisition-hi-rez.jpg",
    icon: false,
    link: '/game_store/new_widget',
    intTime: "less than 3 minutes",

    callToAction__title: 'Create widget',

    steps: [
    {
      step: "Connect Xsolla Partner Network",
      progress: 1,
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    {
      progress: 1,
      step: "Select the game you want to create partner program for",
      action: false
    },
    {
      progress: 0,
      step: "Select the game you want to create partner program for",
      action: false
    },
    {
      progress: 0,
      step: "Choose the type of program",
      action: false
    },
  ]
  },
]

export const microtransactionsSolutions = [




  {
    tag: ['before', 'after'],
    platform: ['win', 'web'],
    monetization: ['premium'],

    badgeText: "Monetize free2play",
    title: "Sell in-game items",
    description: "Send your game to players as a self-contained file instead of a game key, linking them to the download site from within their purchase confirmation.",
    descrLong: "Long Description",
    image: "https://cdn3.xsolla.com/img/misc/images/85c4ef4387ac8e4a985d35ab74aa12bd.png",
    icon: false,
    link: '/microtransactions/virtual_items',

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    tag: ['after'],
    platform: ['win', 'web', 'mobile'],
    monetization: ['microtransactions',],

    badgeText: "Monetize free2play",
    title: "Manage in-game economics and sell virtual currency",
    description: "Microtransactions are in-game purchases that typically help players advance in your game or let them customize their avatars.",
    descrLong: "Long Description",
    image: "https://uploads-ssl.webflow.com/5d2d1e42b1d78992ec4bcf44/5dcbc1f0741bd74d6f940ed5_vc.jpg",
    icon: false,
    link: '/microtransactions/virtual_currency',

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
]



export const subscriptionsSolutions = [
  {
    inProgress: true,

    tag: ['before'],
    platform: ['win', 'web', 'console', 'mobile'],
    monetization: ['funding'],

    badgeText: "Subscriptions",
    title: "Get recurring payments",
    description: "Grow a more stable, consistent revenue stream with flexible plans that grant premium access to your content.",
    descrLong: "Long Description",
    // image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3fe504bb75e8c689104f27_Xsolla---User-acquisition-hi-rez.jpg",
    icon: false,
    link: '/subscriptions/new',

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    tag: [
      'before',
      'launch',
     'after'],
    platform: ['win', 'web'],
    monetization: ['premium', 'funding'],

    badgeText: "Subscriptions",
    title: "Use Subscriptions",
    description: "Grow a more stable, consistent revenue stream with flexible plans that grant premium access to your content.",
    descrLong: "Long Description",
    // image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3fe504bb75e8c689104f27_Xsolla---User-acquisition-hi-rez.jpg",
    icon: false,
    link: '/subscriptions/new',

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },

]

export const currencySolutions = [
  {
    tag: ['before'],
    platform: ['win', 'web', 'console', 'mobile'],
    monetization: ['premium', 'subscriptions', 'funding'],

    badgeText: "For early stages",
    title: "Start a pre-orders or crowdfunding campaign",
    description: "Drive valuable pre-sales to deepen your development and marketing funds, grow your player base, and test your build before your official launch.",
    descrLong: "Long Description",
    link: '/game_store/new_widget',

    image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3fe504bb75e8c689104f27_Xsolla---User-acquisition-hi-rez.jpg",

    icon: <ProductIcon
      // size="xs"
      width={24}
      height={24}
      name='microtransactions'
    />,

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },

  {
    tag: ['before'],
    platform: ['win', 'web', 'console', 'mobile'],
    monetization: ['funding'],

    badgeText: "Before launch",
    title: "Distribute your digital game or content",
    description: "Send your game to players as a self-contained file instead of a game key, linking them to the download site from within their purchase confirmation.",
    image: "https://uploads-ssl.webflow.com/5d2d1e42b1d78992ec4bcf44/5dc6410b52f69fba7785b0d6_BB_sell-your-game_2.jpg",
    descrLong: "Long Description",
    icon: false,
    link: '/game_store/new',

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },

  {
    tag: ['before'],
    platform: ['win', 'web', 'mobile'],
    monetization: ['premium', 'subscriptions',],

    badgeText: "Monetize free2play",
    title: "Sell in-game items an currency",
    description: "Send your game to players as a self-contained file instead of a game key, linking them to the download site from within their purchase confirmation.",
    descrLong: "Long Description",
    image: "https://cdn3.xsolla.com/img/misc/images/85c4ef4387ac8e4a985d35ab74aa12bd.png",
    icon: false,
    link: '/microtransactions/virtual_items',

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    tag: ['before'],
    platform: ['win', 'web', 'mobile'],
    monetization: ['microtransactions', 'funding'],

    badgeText: "Monetize free2play",
    title: "Manage in-game ecomomics and sell virtual currency",
    description: "Microtransactions are in-game purchases that typically help players advance in your game or let them customize their avatars.",
    descrLong: "Long Description",
    // image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3fe504bb75e8c689104f27_Xsolla---User-acquisition-hi-rez.jpg",
    icon: false,
    link: '/microtransactions/virtual_currency',

    intTime: "less than 3 minutes",
    intStep0: "",
    intStep1: {
      step: "Connect Xsolla Partner Network",
      action: "https://publisher.xsolla.com/22867/network/projects/new/campaigns/new"
    },
    intStep2: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep3: {
      step: "Select the game you want to create partner program for",
      action: false
    },
    intStep4: {
      step: "Choose the type of program",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },



]

export const paystationSolutions = [
  {
    inProgress: true,

    tag: ['before'],
    platform: ['win', 'web', 'console', 'mobile'],
    monetization: ['microtransactions', ],

    badgeText: "Payments",
    title: "Use Pay Station to receive payments globally",
    description: "Xsolla Pay Station lets you monetize for every economy, with 700+ payment types worldwide.",
    descrLong: false,
    // image: 'https://assets.website-files.com/5d303aa1e8832120171290c0/5d424b7a41794cdca24f1794_5d766efea45c8a3009791440a4b88581.jpg',
    image: 'https://cdn3.xsolla.com/img/misc/images/ea067fa50252176aefd20166b40dd1af.png',
    link: '/paystation/methods#apple',
    icon: false,
    intTime: "less than 3 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    tag: ['before'],
    platform: ['win', 'web', 'console', 'mobile'],
    monetization: ['microtransactions'],

    badgeText: "Your account manager recommends",
    title: "Connect Alipay to drive payments in China",
    description: "Alipay lets you drive growth through direct relationships with players in China— while keeping their data under your control — and easy communications via pre-integrated modules and 3rd-party connectors.",
    descrLong: false,
    image: 'https://cdn3.xsolla.com/img/misc/images/037454b3863453a35aa4ed5288cc76e4.jpg',
    link: '/paystation/methods#apple',
    icon: false,
    intTime: "less than 3 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
]




export const sitebuilderSolutions = [
  {
    tag: ['before'],
    platform: ['win', 'web', 'console', 'mobile'],
    monetization: ['subscriptions',],

    badgeText: "",
    title: "Create a selling page in minutes with Xsolla Site Builder",
    description: "Launch a customizable, secure website where you can entice players to join the world of your game.",
    descrLong: false,
    image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3055fdbe8118a6072c1e1a_2018-05-03%2001_15_49.gif",
    icon: false,
    link: '/site_builder/newsite',
    intTime: "less than 5 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    tag: ['before', 'after', 'launch'],
    platform: ['win', 'web', 'console', 'mobile'],
    monetization: ['subscriptions',],

    badgeText: "",
    title: "Start Customer Funded Development",
    description: "Subscription-based monetization using your website",
    descrLong: false,
    image: "https://cdn3.xsolla.com/img/misc/images/56289ae3d002e1554ee9d02abc0b0f7b.png",
    icon: false,
    link: '/site_builder/newsite',
    intTime: "less than 5 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  // {
  //   tag: ['before'],
  //   platform: ['win', 'web', 'console', 'mobile'],
  //   badgeText: "Used by Twitch",
  //   title: "Set up SEO settings for your project {ProjectName}",
  //   description: "Grow your organic traffic via setting Google search results preview and sharing options for your Landing Page.",
  //   descrLong: false,
  //   image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3055fdbe8118a6072c1e1a_2018-05-03%2001_15_49.gif",
  //   icon: false,
  //   link: '/site_builder/settings',
  //   intTime: "less than 5 minutes",
  //   intStep0: {
  //     step: false,
  //     action: false
  //   },
  //   intStep1: {
  //     step: false,
  //     action: false
  //   },
  //   intStep2: {
  //     step: "",
  //     action: false
  //   },
  //   intStep3: {
  //     step: "",
  //     action: false
  //   },
  //   intStep4: {
  //     step: "",
  //     action: false
  //   },
  //   intStep5: {
  //     step: "",
  //     action: false
  //   }
  // },
]

export const launcherSolutions = [
  {
    tag: ['after'],
    platform: ['win', 'web'],
    monetization: ['subscriptions'],

    badgeText: "Used by Twitch",
    title: "Set up SEO settings for your project {ProjectName}",
    description: "Grow your organic traffic via setting Google search results preview and sharing options for your Landing Page.",
    descrLong: false,
    image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3055fdbe8118a6072c1e1a_2018-05-03%2001_15_49.gif",
    icon: false,
    link: '/launcher/new',
    intTime: "less than 5 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
]

export const partnernetworkSolutions = [
  {
    tag: ['after'],
    platform: ['win', 'web'],
    monetization: ['microtransactions', 'premium', 'funding'],

    badgeText: "Used by Twitch",
    title: "Set up SEO settings for your project {ProjectName}",
    description: "Grow your organic traffic via setting Google search results preview and sharing options for your Landing Page.",
    descrLong: false,
    image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3055fdbe8118a6072c1e1a_2018-05-03%2001_15_49.gif",
    icon: false,
    link: '/partner_network',
    intTime: "less than 5 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
]

export const loginSolutions = [
  {
    tag: ['before'],
    platform: ['win', 'web', 'mobile'],
    monetization: ['microtransactions', 'premium', 'subscriptions',],

    badgeText: "Global reach",
    title: "Enable Asian login options",
    description: "Improve login convenience with localized, prioritized authentication method display.",
    descrLong: false,
    image: "https://cdn3.xsolla.com/img/misc/images/037454b3863453a35aa4ed5288cc76e4.jpg",
    icon: false,
    link: '/login/social',
    intTime: "less than 5 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
  {
    tag: ['before'],
    platform: ['win', 'web', 'mobile'],
    monetization: ['microtransactions', 'premium', 'subscriptions', ],

    badgeText: "Customize",
    title: "Customize your login widget",
    description: "Match your brand’s style and design with white-label design customization.",
    descrLong: false,
    image: "https://assets.website-files.com/5d303aa1e8832120171290c0/5d3055fdbe8118a6072c1e1a_2018-05-03%2001_15_49.gif",
    icon: false,
    link: '/login/widget',
    intTime: "less than 5 minutes",
    intStep0: {
      step: false,
      action: false
    },
    intStep1: {
      step: false,
      action: false
    },
    intStep2: {
      step: "",
      action: false
    },
    intStep3: {
      step: "",
      action: false
    },
    intStep4: {
      step: "",
      action: false
    },
    intStep5: {
      step: "",
      action: false
    }
  },
]